


import appSettings from 'src/Ateam-BI/CorpReporting/app_settings'
import { FRISCO_STATUS, FRISCO_TRACK_CURRENT_STATUS, FRISCO_TRACK_OVERALL_STATUS, PROCESS_KEYS } from 'src/Ateam-BI/Frisco/Constants'
import { getFriscoProcessWithTracksForQuarter } from 'src/Ateam-BI/Templates/Utils/AppActivityUtils'

export const request = (request, onResponse) => {
    let corpReporingId = appSettings[request?.stage]['appId']
    if (request?.appId == corpReporingId) {
        onResponse({
            'allowWBSelection': true,
            'allowSupportingDocUpload': true,
            'requireCertificationCheck': true, 
            'hideLoadTable': true,
            'shouldShowErrorDisclaimer': true
        })

    } else {
        onResponse({  })
    }
}

export const disabled = (request, onResponse) => {
    let corpReporingId = appSettings[request?.stage]['appId']
    if (request?.appId == corpReporingId) {
        onResponse({
            'disabled': (request?.info?.custom_attributes?.find(attr => attr.attribute_type === "DISABLED")?.attribute || "false") === "true",
            'annualOnly': (request?.info?.custom_attributes?.find(attr => attr.attribute_type === "CADENCE")?.attribute || "") === "ANNUALLY"
        })

    } else {
        onResponse({  })
    }
}


export const getFilteredWbOptions = (processData) => {
    if (!processData?.custom_attributes) {
        return [{ value: "PreWB", label: "Pre WB" }];
    }

    const noPreWbAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_PRE_WB_DUE_DATE"
    );
    
    const noPostWbAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_POST_WB_DUE_DATE"
    );

    const noPostTaxAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_POST_TAX_DATE"
    );

    const postTaxDateAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "POST_TAX_DATE"
    );

    const preWbEnabled = noPreWbAttribute?.attribute !== "true";
    const postWbEnabled = noPostWbAttribute?.attribute !== "true";
    const postTaxEnabled = noPostTaxAttribute?.attribute === "false" && postTaxDateAttribute?.attribute && postTaxDateAttribute?.attribute !== "NaN";

    let filteredOptions = [];

    // if pre wb is true: push pre wb 
    if (preWbEnabled) {
        filteredOptions.push({ value: "PreWB", label: "Pre-WB" });
    }

    // if post wb is true
    if (postWbEnabled) {
        // if pre wb is true : push post wb and no post wb
        if (preWbEnabled) {
            filteredOptions.push({ value: "PostWB", label: "Post-WB" });
            filteredOptions.push({ value: "NoPostWB", label: "No Post-WB" });
        } else {
            // else push only post wb
            filteredOptions.push({ value: "PostWB", label: "Post-WB" });
        }
    }

    // if post tax is enabled, push Pre-WB Post Tax and remove pre wb
    if (postTaxEnabled) {
        filteredOptions.push({ value: "PreWBPostTax", label: "Pre-WB Post Tax" });
    } 

    return filteredOptions;
}

export const getProcessNameMaxLength = (appId, stage) => {
    const corpReportingId = appSettings[stage]?.appId;
    // 10 being the limit for process name field for corporate reporting friscos
    return appId == corpReportingId ? 10 : null;
}



